var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('Base',{style:([_vm.styles])},[_c('div',{staticClass:"wrapper"},[_c('iframe',{staticStyle:{"width":"100%","height":"700px"},attrs:{"src":`https://configurator.andtradition.com/en?iframe&family=${_vm.family}`,"frameborder":"0","allowfullscreen":"","allow":"clipboard-write fullscreen","loading":"lazy"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }